const SalesforceMinIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.19246 2.17239C9.86784 1.45459 10.8078 1.01009 11.8463 1.01009C13.2309 1.01009 14.4309 1.79543 15.0771 2.96559C15.6506 2.70381 16.2719 2.56866 16.9002 2.56899C19.3925 2.56899 21.4155 4.65014 21.4155 7.2182C21.4155 9.78627 19.3925 11.8674 16.9002 11.8674C16.5955 11.8674 16.2986 11.8362 16.0078 11.7771C15.4425 12.8059 14.3617 13.5049 13.1309 13.5049C12.6298 13.5059 12.1352 13.3898 11.6848 13.1656C11.1117 14.5399 9.77707 15.5059 8.22323 15.5059C6.60015 15.5059 5.22323 14.4614 4.69246 12.9928C4.45623 13.0437 4.21543 13.0693 3.974 13.0691C2.04323 13.0691 0.481689 11.4513 0.481689 9.46443C0.481689 8.12936 1.18477 6.96705 2.22784 6.33878C2.00655 5.81834 1.89265 5.25693 1.89323 4.68957C1.89323 2.39637 3.71631 0.542969 5.96246 0.542969C7.27784 0.542969 8.45477 1.18302 9.19323 2.17648"
      fill="#00A1E0"
    />
  </svg>
);
export default SalesforceMinIcon;
